export default {
  allAppraisalTypes: [],
}
